export const useIsOlderSafari = () => {
  if (typeof navigator === "undefined") return false;
  try {
    const ua = navigator.userAgent;

    // Must be Safari with Version/, and not Chrome/Chromium/Edg or iOS variants
    const isSafari =
      /Safari\//.test(ua) &&
      /Version\//.test(ua) &&
      !/(Chrome|Chromium|CriOS|Edg|EdgiOS|OPR|FxiOS)\//.test(ua);

    const match = ua.match(/Version\/([0-9]+)/);
    const major = match?.[1] ? parseInt(match[1], 10) : 0;

    return isSafari && major > 0 && major < 16;
  } catch {
    return false;
  }
};
